import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps/';
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer';

import styles from './styles';
import Marker from './Marker';
import formatCoordinate from './helpers/formatCoordinate';

class Map extends Component {
    constructor() {
        super();

        this.onZoomChanged = this.onZoomChanged.bind(this);
    }

    setPan(x = -150, y = 0) {
        // move center of map
        this.map.panBy(x, y);
    }

    getBounds(locations) {
        const bounds = new window.google.maps.LatLngBounds();
        locations.forEach((location) => {
            const latlng = new window.google.maps.LatLng(
                formatCoordinate(location.lat),
                formatCoordinate(location.lng),
            );
            bounds.extend(latlng);
        });
        return bounds;
    }

    componentDidMount() {
        const bounds = this.getBounds(this.props.locations);
        this.map.fitBounds(bounds);
        if (this.props.enableList) {
            this.setPan();
        }
    }

    onZoomChanged() {
        this.props.setZoom(this.map.getZoom());
    }

    componentDidUpdate(prevProps) {
        // update map bounds according to filtereted locations
        if (
            this.props.filteredLocations.length &&
            prevProps.filteredLocations.length !==
                this.props.filteredLocations.length
        ) {
            const bounds = this.getBounds(this.props.filteredLocations);
            if (this.props.fitOffset) {
                const extendPoint1 = new window.google.maps.LatLng(
                    bounds.getNorthEast().lat() + this.props.fitOffset,
                    bounds.getNorthEast().lng() + this.props.fitOffset,
                );
                const extendPoint2 = new window.google.maps.LatLng(
                    bounds.getNorthEast().lat() - this.props.fitOffset,
                    bounds.getNorthEast().lng() - this.props.fitOffset,
                );
                bounds.extend(extendPoint1);
                bounds.extend(extendPoint2);
            }

            this.map.fitBounds(bounds);
            if (this.props.enableList) {
                this.setPan();
            }
        }
    }

    render() {
        const markers = this.props.locations.map(location => {
            const index = location.categories.findIndex(c => c === location.category.slug) + 1;
            return (
                <Marker
                    key={location.id}
                    width={75}
                    height={106}
                    image={location.title ? `/static/images/map/pin-${index}.png` : null}
                    isOpen={location.title ? location.open : null}
                    toggleLocation={
                        location.title ? this.props.toggleLocation : null
                    }
                    {...location}
                />
            )
        });

        return (
            <GoogleMap
                ref={(map) => {
                    this.map = map;
                }}
                defaultOptions={{
                    styles,
                    mapTypeControl: false,
                    zoomControl: true,
                    scrollwheel: false,
                    fullscreenControl: false,
                    zoomControlOptions: {
                        position:
                            window.google.maps.ControlPosition.RIGHT_CENTER,
                        style: window.google.maps.ZoomControlStyle.LARGE,
                    },
                    scaleControl: true,
                    streetViewControl: false,
                }}
                center={this.props.center}
                zoom={this.props.zoom}
                onZoomChanged={this.onZoomChanged}
            >
                {this.props.enableClusters ? (
                    <MarkerClusterer
                        averageCenter
                        enableRetinaIcons
                        gridSize={60}
                        maxZoom={16}
                        defaultStyles={[
                            {
                                url: '/static/images/map/cluster_icon.svg',
                                height: 33,
                                width: 33,
                                anchor: [0, 0],
                                textColor: '#ffffff',
                                textSize: 14,
                                fontWeight: 'bold',
                            },
                        ]}
                    >
                        {markers}
                    </MarkerClusterer>
                ) : (
                    markers
                )}
            </GoogleMap>
        );
    }
}

Map.defaultProps = {
    enableClusters: false,
    enableList: false,
    center: null,
};

Map.propTypes = {
    locations: PropTypes.arrayOf(PropTypes.object).isRequired,
    filteredLocations: PropTypes.arrayOf(PropTypes.object).isRequired,
    setZoom: PropTypes.func.isRequired,
    toggleLocation: PropTypes.func.isRequired,
    center: PropTypes.object,
    zoom: PropTypes.number.isRequired,
    enableClusters: PropTypes.bool,
    enableList: PropTypes.bool,
    fitOffset: PropTypes.number.isRequired,
};

export default withScriptjs(withGoogleMap(Map));



// WEBPACK FOOTER //
// ./static/js/modules/locations-finder/Map.js